export default __webpack_public_path__ + "images/1d41a779e78a37ad7a8e291f23744d4a-networking.jpg";